import { render, staticRenderFns } from "./ViewTranscriptModal.vue?vue&type=template&id=63554879&"
import script from "./ViewTranscriptModal.vue?vue&type=script&lang=js&"
export * from "./ViewTranscriptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports